import type { ReactNode } from "react";
import aiAvatar from "../../assets/ai-avatar.png";
import { GradientSpinner } from "../common/GradientSpinner";

interface AIAvatarRowProps {
  children: ReactNode;
  showSpinner?: boolean;
}

export function AIAvatarRow({ children, showSpinner }: AIAvatarRowProps) {
  return (
    <div className="flex items-start gap-2 pr-6 lg:gap-3 lg:pr-[120px]">
      <div className="shrink-0 rounded-full bg-gradient-to-r from-gradient-start to-gradient-end p-px">
        <div className="size-8 lg:size-10 overflow-hidden rounded-full bg-white flex items-center justify-center">
          {showSpinner ? (
            <GradientSpinner size={24} />
          ) : (
            <img
              src={aiAvatar}
              alt="Dahling AI"
              className="size-full object-cover"
            />
          )}
        </div>
      </div>
      {children}
    </div>
  );
}
